import AppRouting from "AppRouting";
import "./App.css";

function App() {
  return (
    <>
      <AppRouting />
    </>
  );
}

export default App;
